<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch2">
<div class="chapterHead">
<p class="centerImage3"><img alt="image" src="images/ch2.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-2">“What do you mean I can’t live there?” Nick asks, laughing. “I know my own house.”</a></p><a id="pg-2">
<p class="para" style="text-indent: 5%;">“I live next door,” you tell him. You point to the redbrick house next to the green one. “The green house has been empty all month. There haven’t been any lights on. No cars in the driveway.”</p>
<p class="para" style="text-indent: 5%;">“I was on vacation with my family. We got back last night,” Nick says. “What do you think of school?”</p>
<p class="para" style="text-indent: 5%;">“Okay, I guess,” you reply. You’re afraid to say anything more. You never know — maybe this kid Nick actually <em class="italic">likes</em> school.</p>
<p class="para" style="text-indent: 5%;">“Can you believe how much homework our teacher gave us this weekend?” Nick complains. He kicks a stone down the street as you walk. “All the kids who had Mr. McCormick last year say he’s really tough. And mean. A total monster!”</p>
<p class="para" style="text-indent: 5%;">You agree. The next thing you know you and Nick are comparing favorite rock groups and comic books. Both of you collect Spider-Man comics. Nick has all the first issues from the last five years, too!</p>
<p class="para" style="text-indent: 5%;">“Comics are cool,” Nick says. “But do you know what’s even cooler?”</p>
<p class="para" style="text-indent: 5%;">“What?” you ask.</p>
<p class="para" style="text-indent: 5%;">“Horror stories!” Nick exclaims. “In fact, I —” He stops talking and stares at you.</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-2"><em class="italic">Turn to </em></a><a href="#/e9780545841030_ch003"><em class="italic">PAGE 3</em></a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841030_ch002.vue?c9a7742c